import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

interface Props {
  registeredCount: number;
  durationLabel: string;
  priceLabel: string;
  capacityLabel: string;
}

const InfoGrid: React.FC<Props> = ({ registeredCount, durationLabel, priceLabel, capacityLabel }) => {
  return (
    <View style={styles.infoGrid}>
      <View style={styles.infoCard}>
        <MaterialCommunityIcons name="account-group" size={24} color="#2C67D6" />
        <Text style={styles.infoCardNumber}>{registeredCount}</Text>
        <Text style={styles.infoCardLabel}>Registered</Text>
      </View>

      <View style={styles.infoCard}>
        <MaterialCommunityIcons name="calendar-range" size={24} color="#34C759" />
        <Text style={styles.infoCardNumber}>{durationLabel}</Text>
        <Text style={styles.infoCardLabel}>Duration</Text>
      </View>

      <View style={styles.infoCard}>
        <MaterialCommunityIcons name="cash" size={24} color="#FF9500" />
        <Text style={styles.infoCardNumber}>{priceLabel}</Text>
        <Text style={styles.infoCardLabel}>Price</Text>
      </View>

      <View style={styles.infoCard}>
        <MaterialCommunityIcons name="account-multiple-check" size={24} color="#28A745" />
        <Text style={styles.infoCardNumber}>{capacityLabel}</Text>
        <Text style={styles.infoCardLabel}>Capacity</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  infoGrid: { flexDirection: 'row', flexWrap: 'wrap', marginBottom: 32, gap: 16 },
  infoCard: { flex: 1, minWidth: 160, backgroundColor: '#f8f9fa', borderRadius: 16, padding: 20, alignItems: 'center', borderWidth: 1, borderColor: '#e9ecef' },
  infoCardNumber: { fontSize: 28, fontWeight: '700', color: '#1a1a1a', marginTop: 12, marginBottom: 4 },
  infoCardLabel: { fontSize: 14, color: '#666', fontWeight: '500' },
});

export default InfoGrid;


